/** @format */

import { DeviceInfo } from './device-info.interface';

export interface AtcMessage {
  bopisSelected: boolean;
  bopisStore: string;
  browser: string;
  callOrigin: string;
  chain: string;
  dcsgNgxPageUrl: any;
  deviceInfo: DeviceInfo;
  eCode: string;
  errorMessage: string;
  logType: string;
  multiSku?: string[];
  quantity: number | string;
  skuId: string;
  success: string;
  swimlane: number;
  title: string;
  warrantyEcode?: string;
}
